<div class="tabs d-flex flex-row border-shape-border user-select-none" [class.show-border]="showBorder">
  <div
    *ngFor="let tab of tabs"
    (click)="changeNav(tab)"
  >
    <div
      class="text-center tab"
      [style.padding-top]="paddingVertical"
      [style.padding-bottom]="paddingVertical"
      [class.tab-disabled]="disabled"
      [class.active]="isActiveTab(tab)"
      [class.text-bold]="boldText"
    >
      @if (customContent[tab]) {
        <ng-container *ngTemplateOutlet="customContent[tab]"></ng-container>
      } @else {
        {{ tab | titlecase }}
      }
    </div>
  </div>

</div>

<ng-content></ng-content>
